/** Convert the powerbi-client object into an angular injectable */

export class PowerBiClientFactory {
    public static $name: string = 'powerBiClient';

    public static $inject: string[] = [
        '$window'
    ];

    constructor(
        private $window: angular.IWindowService
    ) {
        let key = 'powerbi-client';

        /** Assign a local pointer to the global reference's address */
        let powerBiClient = $window[key];

        /**
         * Remove the global reference so that powerbi-client by ONLY be used by injection.
         * The local reference to the same object is kept
         */
        delete $window[key];

        return powerBiClient;
    }
}
